import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

export interface SigningInProgressModalProps {
  message?: string;
}

export const SigningInProgressModal: React.FC<
  SigningInProgressModalProps
> = props => {
  return (
    <Modal
      show={true}
      backdrop="static"
      keyboard={false}
      centered
      contentClassName="p-4 rounded-4"
    >
      <Modal.Body className="text-center">
        <Spinner
          animation="border"
          role="status"
          style={{
            width: '4rem',
            height: '4rem',
            marginBottom: '1rem',
            color: '#0d6efd',
          }}
        >
          <span className="visually-hidden">Signing in progress...</span>
        </Spinner>
        <h4 className="mb-3">{props.message ?? 'Podpisywanie dokumentu'}</h4>
        <p className="text-muted mb-0">Proszę chwilę zaczekać...</p>
      </Modal.Body>
    </Modal>
  );
};
